<template>
  <div class="configure-three">
    <div class="left zdcenter">
      <p class="title titleZt zdcenter">图源列表</p>
      <div class="collapse">
        <el-collapse v-model="selectedGroupId" class="collapse-warp" accordion>
          <el-collapse-item v-for="(item,index) in defaultStore" class="collapse-item" :key="index" :title="item.name" :name="item.id">
            <div class="components-warp-content">
              <template v-for="(obj,i) in item.components">
                <div class="graph-source-item" :key="i" :draggable="true" @dragstart="dragstart($event,obj,item)">
                  <div :key="i" :class="['graph-source-img',item.name == '传感器'||item.name == '摄像头'?'cgq':'']" v-if="obj.img">
                    <img :src="obj.img" />
                  </div>
                  <div :key="i" class="graph-source-text" v-else>
                    <div class="text-info"></div>
                  </div>
                  <p class="sub-title zt">{{obj.measureName}}</p>
                </div>
              </template>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="center zdcenter" @drop.prevent="drop($event)" @dragover.prevent="dragover($event)">
      <img src="/img/baseNew2.png" style="position: absolute;left: 0px;top: 0px;" :draggable="false" />
      <vdr v-for="(item,index) in list" :key="index" :w="item.width" :h="item.height" :x="item.x" :y="item.y" :resizable="false" @activated="activated(index)" @dragstop="dragstop">
        <img :src="item.img" :style="{width:item.width+'px',height:item.height+'px'}" />
      </vdr>
      <vdr v-for="(item,index) in comList" :key="index+'com'" :w="item.width" :h="item.height" :x="item.x" :y="item.y" :resizable="false" @activated="comActivated(index)" @dragstop="comDragstop">
        <component :is="item.comName" :control.sync="item.control"></component>
      </vdr>
    </div>
    <div class="right zdcenter">
      <div class="btn">
        <el-button size="small" class="btn-item" @click="btnClick(0)">返&nbsp;&nbsp;回</el-button>
        <el-button type="primary" size="small" class="btn-item" @click="btnClick(1)">保&nbsp;&nbsp;存</el-button>
        <el-button type="danger" size="small" class="btn-item" @click="btnClick(2)">删&nbsp;&nbsp;除</el-button>
      </div>
      <div class="item-info" v-show="isListShow">
        <div class="info-item">
          <p class="info-item-title zt">当前电房：</p>
          <el-input v-model="itemInfo.dfName" :disabled="true" size="small"></el-input>
        </div>
        <div class="line"></div>
        <div class="info-item">
          <p class="info-item-title zt">元件名称：</p>
          <el-input v-model="itemInfo.name" size="small" @input="input($event,'name')"></el-input>
        </div>
        <div class="info-item">
          <p class="info-item-title zt">水平位置：</p>
          <el-input v-model="itemInfo.x" :disabled="true" size="small"></el-input>
        </div>
        <div class="info-item">
          <p class="info-item-title zt">垂直位置：</p>
          <el-input v-model="itemInfo.y" :disabled="true" size="small"></el-input>
        </div>
        <div class="info-item">
          <p class="info-item-title zt">测量点ID：</p>
          <el-input v-model="itemInfo.id" size="small" @input="input($event,'id')" @change="idChange($event,itemInfo.rq)"></el-input>
        </div>
        <div class="info-item" v-if="itemInfo.rqArr.length != 0 ? true : false">
          <p class="info-item-title zt">所属容器：</p>
          <el-select v-model="itemInfo.rqId" @change="selectChange" :disabled="itemInfo.id != undefined ? (itemInfo.id.length === 0 ? true : false) : false" placeholder="请选择" size="small" class="select">
            <el-option v-for="item in itemInfo.rqArr" :key="item.name" :label="item.displayName" :value="item.name"></el-option>
          </el-select>
        </div>
      </div>
      <div class="item-info" v-show="!isListShow">
        <component :is="paramsName.name" :control.sync="paramsName.control"></component>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../../../common/api/index"
import threeText from "@/components/page/configure/threeText";
import threeTextParams from "@/components/page/configure/threeTextParams";
export default {
  name: 'ConfigureThree',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    threeText, threeTextParams
  },
  data () {
    return {
      defaultStore: window.baseConfig.assetsParam.list,
      selectedGroupId: window.baseConfig.assetsParam.list[0].id,
      list: [],//展示区的数据
      comList: [],//额外组件显示的数据
      isListShow: true,//是否展示图片区的信息
      paramsName: {},//参数组件信息
      thisComIndex: -1,//当前选中的组件下标
      itemInfo: {//当前选中的元件信息
        name: "",
        x: "",
        y: "",
        rqId: "",//容器ID
        id: "",//测量点ID
        rqArr: [],
        dfName: ""//配电房名称
      },
      thisIndex: -1,//当前点击中的元件,-1表示未选中
      content: "",//当前行的数据信息
    }
  },
  watch: {
    rowData: {
      handler (newVal, oldVal) {
        if (newVal.id) {
          this.getData();
        }
      },
      deep: true
    },
    paramsName: {
      handler (newVal, oldVal) {
        if (this.thisComIndex >= 0) {
          this.comList[this.thisComIndex].control = JSON.parse(JSON.stringify(newVal.control));
        }
      },
      deep: true
    }
  },
  methods: {
    async getData () {//点击表格编辑后，获取上一次保存的数据
      this.content = JSON.parse(this.rowData.content);
      this.list = this.content.components;
      this.comList = this.content.comList || [];
      this.itemInfo.dfName = this.rowData.name;
    },
    async btnClick (type) {
      if (type === 0) {//返回到表格
        this.$confirm('该界面有改动，尚未保存, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.list = [];
          this.refItemInfo(true);//恢复原始
          this.$emit("update:isEdit", false);//退出编辑状态
          this.$emit("update:rowData", {});
        });
      } else if (type === 1) {//点击保存
        let content = {
          base: this.content.base,
          components: this.list,
          comList: this.comList
        }
        let res = await api.diyComponent.modifyFrontEndDIYPageContent(this.rowData.id, "", JSON.stringify(content));
        if (res.success) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } else {//点击删除
        if (this.thisIndex != -1) {//存在可以删除的
          if (!this.isListShow) {
            this.comList.splice(this.thisIndex, 1);
          } else {
            this.list.splice(this.thisIndex, 1);
          }
          //删除后，恢复到默认
          this.refItemInfo(false);
        } else {
          this.$message.error("请选择要删除的元件");
        }
      }
    },
    dragstart (ev, val, parVal) {//拖动的元素
      if (parVal.flag) {
        let temp = this.list.find((item) => {
          return item.name === val.measureName;
        });
        if (temp) {
          this.$message.error('当前元件只能存在一个');
          ev.dataTransfer.setData("imgInfo", "");
          return;
        }
      }
      ev.dataTransfer.setData("imgInfo", JSON.stringify(val));
    },
    dragover (ev) {//拖拽的元素在放置区移动时触发
      ev.preventDefault();
    },
    drop (ev) {//放置的时候触发
      ev.preventDefault();
      let temp = JSON.parse(ev.dataTransfer.getData("imgInfo"));
      if (!temp) {
        return;
      }
      if (temp.type === "othersCom") {
        this.comList.push({
          width: temp.width,
          height: temp.height,
          x: ev.layerX,//放置时的x位置
          y: ev.layerY,//放置时的y位置
          comName: temp.comName,
          control: temp.control,
          params: temp.params
        });
      } else {
        this.list.push({
          width: temp.width,
          height: temp.height,
          x: ev.layerX,//放置时的x位置
          y: ev.layerY,//放置时的y位置
          img: temp.leaveImg,
          enterImg: temp.enterImg,
          notImg: temp.notImg,
          name: temp.measureName,
          hover: false,//鼠标是否经过标识
          rq: temp.rq,//是否是容器
          isCamera: temp.isCamera,//是否是摄像头
          type: temp.type//计算烟感等类型需要
        })
      }
    },
    async activated (index) {//单击元件的时候
      this.isListShow = true;
      this.thisComIndex = -1;
      let val = this.list[index];
      this.thisIndex = index;
      this.itemInfo.name = val.name;
      this.itemInfo.x = val.x;
      this.itemInfo.y = val.y;
      this.itemInfo.id = val.id;
      this.itemInfo.rq = val.rq;
      this.itemInfo.rqId = val.rqId;
      this.itemInfo.rqArr = [];
      if (this.itemInfo.rq && this.itemInfo.id) {//是容器，并且id存在，先查询模板信息
        this.getRqInfo(this.itemInfo.id);
      }
    },
    comActivated (index) {//单击组件信息的时候
      this.isListShow = false;
      this.thisIndex = index;
      let val = this.comList[index];
      this.paramsName = JSON.parse(JSON.stringify({
        name: val.params,
        control: val.control
      }));
      this.thisComIndex = index;
    },
    async getRqInfo (id) {//查询模板信息
      let res = await api.measure.getMeasuresProperties(JSON.stringify([id]));
      if (!res.success) {//失败的情况
        this.$message.error(res.msg);
        return;
      }
      let templateIds = res.data.filter(item => {
        if (item.templateId !== "") {
          return item.templateId;
        }
      });//找到非空的模板id
      if (templateIds.length === 0) {//当前计量点下没有配置模板id
        this.$message.error("当前计量点下没有配置模板id");
        return;
      }
      let displayName = await api.measure.getContainerOfMeasureTemplate(templateIds[0].templateId);//根据模板id查询容器
      if (!displayName.success) {//失败的情况
        this.$message.error(displayName.msg);
        return;
      }
      this.$set(this.itemInfo, "rqArr", displayName.data);
    },
    dragstop (x, y) {//拖拽结束时触发，更新位置信息
      this.list[this.thisIndex].x = x;
      this.list[this.thisIndex].y = y;
      this.itemInfo.x = x;
      this.itemInfo.y = y;
    },
    comDragstop (x, y) {
      this.comList[this.thisComIndex].x = x;
      this.comList[this.thisComIndex].y = y;
    },
    input (val, type) {//文本框实时改变时
      this.list[this.thisIndex][type] = val;
    },
    idChange (val, rq) {//测量点id改变后
      if (val && rq) {//输入的值合法，并且是属于容器才进行查询
        this.getRqInfo(val);//根据当前输入的id，查询模板等信息
      }
    },
    selectChange (val) {//容器下拉框改变事件
      this.list[this.thisIndex].rqId = val;
    },
    refItemInfo (flag) {//恢复原始状态
      this.thisIndex = -1;
      this.itemInfo.name = "";
      this.itemInfo.x = "";
      this.itemInfo.id = "";
      this.itemInfo.rqId = "";
      this.itemInfo.y = "";
      flag ? this.itemInfo.dfName = "" : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.configure-three {
  display: flex;
  width: 100%;
  height: 100%;
  background: #d5dadd;
  .left {
    width: 260px;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .title {
      color: #030a1e;
      padding: 5px;
      font-weight: bold;
    }
    .collapse {
      position: absolute;
      top: 29px;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
      .collapse-warp {
        .collapse-item {
          padding: 0 5px;
          .components-warp-content {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            .graph-source-item {
              text-align: center;
              margin-bottom: 5px;
              cursor: move;
              display: flex;
              flex-flow: column;
              justify-content: space-between;
              .graph-source-img {
                text-align: center;
                img {
                  width: 25px;
                  height: 42px;
                }
              }
              .cgq {
                img {
                  width: auto;
                  height: auto;
                }
              }
              .graph-source-text {
                .text-info {
                  width: 25px;
                  height: 42px;
                  border: 1px dashed #d8d8d8;
                  margin: 0 auto;
                }
              }
              .sub-title {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
  .center {
    width: calc(100% - 540px);
    height: 100%;
    margin: 0 20px;
    border-radius: 4px;
    overflow: auto;
    position: relative;
    .vdr {
      border: none !important;
      cursor: move;
    }
  }
  .right {
    width: 260px;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    .btn {
      display: flex;
      padding: 5px;
      box-sizing: border-box;
      justify-content: space-around;
      .btn-item {
        margin: 0;
      }
    }
    .item-info {
      flex: 1;
      width: 100%;
      border-top: 1px solid #ebeef5;
      padding: 0 5px;
      box-sizing: border-box;
      .info-item {
        display: flex;
        margin-top: 10px;
        align-items: center;
        .info-item-title {
          color: #030a1e;
          font-size: 14px;
          width: 100px;
          text-align: right;
        }
        .select {
          width: 100%;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: #ebeef5;
        margin-top: 10px;
      }
    }
  }
}
</style>